import { useNavigate } from 'react-router-dom'
import { Image } from 'react-bootstrap'
import NewsList from '@/pages/news/list'
import Styles from './style.module.scss'
import useLang from '@/utils/hooks/use-lang'
import { Flex } from 'antd'
import { news as newList } from '@/pages/about-us/news-data'
import HorizontalScroll from '@/components/horizon-list'

const title = {
  en: 'News',
  es: 'Noticias',
  cn: '新闻中心',
}

const btn = {
  en: 'Learn More',
  es: 'Aprender Más',
  cn: '查看更多',
}

export function NewsItem(props) {
  const { item } = props
  return (
    <div className={Styles.newsItem}>
      <Image src={item.image} style={{ height: '100%', width: '100%', objectFit: 'cover' }} />
      <div className={Styles.content}>
        <div className={Styles.title} onClick={() => window.open(item.link)}>
          {item.title}
        </div>
        <div className={Styles.date}>{item.date}</div>
      </div>
    </div>
  )
}

export default function News(props) {
  const [lang] = useLang()

  return (
    <Flex vertical className={Styles.news}>
      <h2>news & blog </h2>
      {!!newList?.length && (
        <HorizontalScroll itemsPerScreen={4} gap={32}>
          {newList.map(item => (
            <NewsItem key={item.id} item={item} />
          ))}
        </HorizontalScroll>
      )}
    </Flex>
  )
}
